import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import TrashImage from "../../../assets/ending/ending.png";

import typography from "../../../theme/typography";

import LongButton from "../../shared/LongButton";

const Page = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  background-color: ${(props) => props.theme.color.black};
`;

const Image = styled.img`
  margin-top: 61px;
  margin-bottom: 19px;
`;

const Text = styled.p`
  position: relative;
  width: 100%;
  height: 150px;
  color: ${(props) => props.theme.color.white};
  ${typography.mainText2};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 58px;
`;

const EndingPage = ({ garbageQtty }) => {
  return (
    <Page>
      <Image src={TrashImage} alt="쓰레기로 차고 넘치는 쓰레기봉투" />

      <Text>
        강제 제로웨이스트
        <br />
        도전 일주일…
        <br />
        <br />
        과연 우리 집은
        <br />
        며칠 동안 버틸 수 있을까?
      </Text>

      <Link to={`/result/${garbageQtty}`}>
        <LongButton text="결과보기" width={150} />
      </Link>
    </Page>
  );
};

export default EndingPage;
